<div mat-dialog-title>
  <h1 style="display: flex;align-items: center;margin-top:-4px;padding-top:8px;">
    <mat-icon style="margin-left:-8px;margin-top:4px;margin-right:-2px;">bolt</mat-icon>
    {{ title }}
  </h1>
  <app-dialog-close-button layoutMode="float" (click)="close()"></app-dialog-close-button>
</div>
<div mat-dialog-content>
  <div
    style="display: flex;flex-direction: column;gap:10px;align-items: stretch;justify-content: stretch;cursor: default">
    <div style="display: flex;align-items: center">
      <span style="min-width:200px;">Original:</span>
      <div style="width:100%"></div>
      <input value="{{ originalString }}"
             style="max-width:200px;min-width:200px;margin-left:3px;padding:0 8px;text-align: right;" disabled>
    </div>
    <div style="display: flex;align-items: center;font-weight: bold;color:#195f30">
      <span style="min-width:200px;">Override:</span>
      <div style="width:100%"></div>
      <input
        autofocus
        [(ngModel)]="customString"
        type="text"
        (keyup.enter)="updateCustomString($event.target.value)"
        style="font-weight:bold;max-width:200px;min-width:200px;margin-left:3px;padding:0 8px;text-align: right;">
    </div>
  </div>
</div>
<div mat-dialog-actions style="display: flex;justify-content: center;gap:24px">
  <button
    mat-button
    style="flex-grow:2;margin:0;background: #7a4e4e;color:#fff;"
    (click)="removeCustomString()">
    Clear Override
  </button>
  <button
    mat-button
    type="submit"
    style="flex-grow:2;margin:0"
    (click)="updateCustomString()"
    [disabled]="!customString">
    Update Override
  </button>
</div>
